module.exports = __webpack_public_path__ + "img/safe_lock.8a9447ca.svg";